import LiveCctv from "./CCTV";
import InformasiTol from "./InformasiTol";
import VirtualTourTollRoad from "./VirtualTourTollRoad";
import TeknologiKami from "./TeknologiKami";
import ArmadaAndKelengkapanOperasi from "../Fasilitas";
import { ScrollTab } from "../../../components";

const data = [
  {
    tab: "Informasi Tol",
    tabPanel: <InformasiTol />,
  },
  {
    tab: "Teknologi Kami",
    tabPanel: <TeknologiKami />,
  },
  {
    tab: "Live CCTV",
    tabPanel: <LiveCctv />,
  },
  {
    tab: "Virtual Tour Toll Road",
    tabPanel: <VirtualTourTollRoad />,
  },
  {
    tab: "Armada dan Perlengkapan Operasi",
    tabPanel: <ArmadaAndKelengkapanOperasi />,
  },
];

const Fasilitas = () => <ScrollTab content={data} />;

export default Fasilitas;
